import { OnInit, EventEmitter } from '@angular/core';
import { AllCommunityModules } from '@ag-grid-community/all-modules';
import { SummaryColumn, Summary, FilterOption } from '../objects/SummaryObject';
import { AgGridAngular } from '@ag-grid-community/angular';
import { SummaryService } from '../services/summary.service';
import { AdvancedTableHeaderComponent } from '../advanced-table-header/advanced-table-header.component';
import { ContextMenuService, ContextMenuComponent } from 'ngx-contextmenu';
import { EnvService } from '../env.service';
import { TokenManager } from '../Globals';
var AdvancedTableComponent = /** @class */ (function () {
    function AdvancedTableComponent(summaryService, contextMenuService, env, tokenManager) {
        var _this = this;
        this.summaryService = summaryService;
        this.contextMenuService = contextMenuService;
        this.env = env;
        this.tokenManager = tokenManager;
        this.isSaving = false;
        this.modules = AllCommunityModules;
        this.columns = [];
        this.blockSize = 10;
        this.rowCount = 0;
        this.totalRowsCount = 0;
        this.toggleClickExport = false;
        this.cleanedColState = [];
        this.gridOptions = {
            maxConcurrentDatasourceRequests: 1,
            defaultColDef: {
                headerComponentFramework: AdvancedTableHeaderComponent,
            },
            loadingCellRenderer: "customLoadingCellRenderer",
            loadingCellRendererParams: { loadingMessage: "One moment please..." },
            infiniteInitialRowCount: 1,
            cacheBlockSize: 100,
            rowModelType: "infinite",
            animateRows: true,
            rowSelection: "multiple",
            suppressDragLeaveHidesColumns: true,
        };
        this.exportSummary = new EventEmitter();
        this.exportCurrentView = new EventEmitter();
        this.isRPF1 = false;
        this.showReportExportCurrentView = this.env.ShowReportExportCurrentView;
        this.summaryService.sortChanged$.subscribe(function (result) {
            if (result) {
                if (result.column) {
                    _this.sortByColumn(result.column.colDef.field);
                }
            }
        });
        this.summaryService.filterChanged$.subscribe(function (result) {
            if (result) {
                if (result.column) {
                    // this.sortByColumn(result.column.colDef.field);
                }
            }
        });
        this.noRowsTemplate = "<span>No record found</span>";
        this.Filterreport = this.env.Filterreport;
    }
    Object.defineProperty(AdvancedTableComponent.prototype, "setSummary", {
        set: function (summary) {
            this.totalRowsCount = summary.TotalRows;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvancedTableComponent.prototype, "setSummaryData", {
        set: function (summaryData) {
            summaryData.forEach(function (data, index) {
                data.id = data['#RowNumber'];
            });
            this.rowData = summaryData;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvancedTableComponent.prototype, "setColumns", {
        set: function (columns) {
            var _this = this;
            var summaryColumns = columns;
            this.columnDefs = [];
            // var idCol = {field: "id"};
            // this.columnDefs.push(idCol);
            summaryColumns.forEach(function (column) {
                var colm;
                if (column.ColumnIsSorted) {
                    var sort = "desc";
                    if (column.ColumnSortIsAsc)
                        sort = "asc";
                    colm = { headerName: column.PropertyDisplay, field: column.PropertyName, sortable: true, sort: sort, resizable: true, cellStyle: { 'text-align': column.ViewColumnType == 'DISPLAYNUMBERFORMAT' ? 'right' : 'left' } };
                }
                else {
                    colm = { headerName: column.PropertyDisplay, field: column.PropertyName, sortable: true, resizable: true, cellStyle: { 'text-align': column.ViewColumnType == 'DISPLAYNUMBERFORMAT' ? 'right' : 'left' } };
                }
                _this.columnDefs.push(colm);
                var displayColm = { headerName: column.PropertyDisplay, field: column.PropertyName, resizable: true, isChecked: true };
                _this.columns.push(displayColm);
            });
        },
        enumerable: true,
        configurable: true
    });
    AdvancedTableComponent.prototype.ngOnInit = function () {
        var currentRoute = this.tokenManager.retrieve("BRNCurrentRoute");
        if (currentRoute) {
            var routeParts = currentRoute.split('/');
            this.isRPF1 = routeParts[3] === this.Filterreport;
        }
        if (this.isRPF1) {
            this.fromdatevalue = this.formatDates(new Date(new Date().setMonth(new Date().getMonth() - this.env.ReportFromDateMonth)));
            this.Fromdatevalue = this.fromdatevalue;
            this.Todatevalue = this.formatDates(this.env.ReportToDate);
            if (!this.fromDate && this.env.ReportFromDateMonth) {
                this.fromDate = new Date(this.Fromdatevalue);
            }
            if (!this.toDate && this.env.ReportToDate) {
                this.toDate = new Date(this.Todatevalue);
            }
        }
    };
    AdvancedTableComponent.prototype.formatDates = function (date) {
        var yyyy = date.getFullYear();
        var mm = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-indexed
        var dd = String(date.getDate()).padStart(2, '0');
        return yyyy + "-" + mm + "-" + dd;
    };
    AdvancedTableComponent.prototype.onContextMenu = function ($event) {
        if ($event.button == 0) {
            this.contextMenuService.show.next({
                anchorElement: $event.target,
                contextMenu: this.basicMenu,
                event: $event,
                item: ''
            });
        }
        $event.preventDefault();
        $event.stopPropagation();
    };
    AdvancedTableComponent.prototype.rowClicked = function ($event) {
        console.log($event);
    };
    AdvancedTableComponent.prototype.resizeColumn = function () {
        this.agGrid.columnApi.autoSizeAllColumns();
    };
    AdvancedTableComponent.prototype.getSelectedRows = function (event) {
        var selectedNodes = this.agGrid.api.getSelectedNodes();
        var selectedData = selectedNodes.map(function (node) { return node.data; });
        var selectedDataStringPresentation = selectedData.map(function (node) { return node.DepartmentName; });
    };
    AdvancedTableComponent.prototype.onGridReady = function (event) {
        if (this.isRPF1) {
            this.gridReady1(event);
        }
        else {
            this.gridReady(event);
        }
    };
    AdvancedTableComponent.prototype.gridReady = function (event) {
        var _this = this;
        this.getState();
        var self = this;
        var datasource = {
            rowCount: null,
            getRows: function (params) {
                if (params.startRow == 0 && !_this.initialLoad) {
                    _this.initialLoad = true;
                    _this.agGrid.api.showLoadingOverlay();
                    _this.summaryService.getSummary(_this.componentId).subscribe(function (result) {
                        var summary = JSON.parse(result);
                        if (summary.Data.length == 0) {
                            _this.agGrid.api.showNoRowsOverlay();
                        }
                        else {
                            _this.agGrid.api.hideOverlay();
                        }
                        _this.totalRowsCount = summary.TotalRows;
                        var summaryData = _this.sortSummaryData(summary.Data);
                        if (summaryData.length > 0) {
                            var slicedData = summaryData.slice(params.startRow, params.endRow);
                            slicedData.forEach(function (data) {
                                data.id = data['#RowNumber'];
                            });
                            var lastRow = -1;
                            if (summaryData.length < params.endRow) {
                                lastRow = summaryData.length;
                            }
                            self.rowCount = summaryData.length;
                            params.successCallback(slicedData, lastRow);
                        }
                        else {
                            self.rowCount = 0;
                            params.successCallback([], 0);
                        }
                    }, function (error) {
                        _this.agGrid.api.hideOverlay();
                    });
                }
                else {
                    _this.initialLoad = false;
                    self.fetchNextChunk(params.startRow, params.endRow).then(function (chunk) {
                        var slicedData = chunk.slice(params.startRow, params.endRow);
                        slicedData.forEach(function (data) {
                            data.id = data['#RowNumber'];
                        });
                        var lastRow = -1;
                        if (chunk.length < params.endRow) {
                            lastRow = chunk.length;
                        }
                        self.rowCount = chunk.length;
                        params.successCallback(slicedData, lastRow);
                    });
                }
            }
        };
        event.api.setDatasource(datasource);
        setTimeout(function () {
            // event.columnApi.autoSizeAllColumns();
        });
    };
    AdvancedTableComponent.prototype.gridReady1 = function (event) {
        var _this = this;
        this.getState();
        var self = this;
        var datasource = {
            rowCount: null,
            getRows: function (params) {
                if (params.startRow == 0 && !_this.initialLoad) {
                    _this.initialLoad = true;
                    _this.agGrid.api.showLoadingOverlay();
                    _this.summaryService.getSummaryFilterOptions(_this.componentId).subscribe(function (result) {
                        _this.filterOptions = JSON.parse(result);
                        var dateFilter = null;
                        if (_this.filterOptions) {
                            dateFilter = _this.filterOptions.find(function (f) {
                                return f.FilterField === 'CreatedSubmittedDateFrom';
                            });
                        }
                        if (dateFilter) {
                            var apiFilters = [];
                            var fromDateStr = _this.fromDate ? _this.fromDate.toISOString() : null;
                            var toDateStr = _this.toDate ? _this.toDate.toISOString() : null;
                            if (fromDateStr || toDateStr) {
                                apiFilters.push({
                                    FilterField: 'CreatedSubmittedDateFrom',
                                    FilterOptionType: 'DATE',
                                    FilterOptionDisplay: 'CreatedSubmittedDate',
                                    FilterType: 'BETWEEN',
                                    FilterOptionItems: [{ IsChecked: true, ItemValue: fromDateStr, ItemDisplay: fromDateStr },
                                        { IsChecked: true, ItemValue: toDateStr, ItemDisplay: toDateStr }],
                                    SelectedFilterItem: [fromDateStr, toDateStr]
                                });
                            }
                            _this.summaryService.changeFilter(_this.componentId, apiFilters)
                                .subscribe(function (result) {
                                if (result === "1") {
                                    _this.summaryService.applyFilters(_this.componentId)
                                        .subscribe(function () {
                                        _this.summaryService.getSummary(_this.componentId).subscribe(function (result) {
                                            var summary = JSON.parse(result);
                                            if (summary.Data.length == 0) {
                                                _this.agGrid.api.showNoRowsOverlay();
                                            }
                                            else {
                                                _this.agGrid.api.hideOverlay();
                                            }
                                            _this.totalRowsCount = summary.TotalRows;
                                            var summaryData = _this.sortSummaryData(summary.Data);
                                            if (summaryData.length > 0) {
                                                var slicedData = summaryData.slice(params.startRow, params.endRow);
                                                slicedData.forEach(function (data) {
                                                    data.id = data['#RowNumber'];
                                                });
                                                var lastRow = -1;
                                                if (summaryData.length < params.endRow) {
                                                    lastRow = summaryData.length;
                                                }
                                                self.rowCount = summaryData.length;
                                                params.successCallback(slicedData, lastRow);
                                            }
                                            else {
                                                self.rowCount = 0;
                                                params.successCallback([], 0);
                                            }
                                        }, function (error) {
                                            _this.agGrid.api.hideOverlay();
                                        });
                                    });
                                }
                            }, function () { return _this.initialLoad = false; });
                        }
                        else {
                            _this.summaryService.getSummary(_this.componentId).subscribe(function (result) {
                                var summary = JSON.parse(result);
                                if (summary.Data.length == 0) {
                                    _this.agGrid.api.showNoRowsOverlay();
                                }
                                else {
                                    _this.agGrid.api.hideOverlay();
                                }
                                _this.totalRowsCount = summary.TotalRows;
                                var summaryData = _this.sortSummaryData(summary.Data);
                                if (summaryData.length > 0) {
                                    var slicedData = summaryData.slice(params.startRow, params.endRow);
                                    slicedData.forEach(function (data) {
                                        data.id = data['#RowNumber'];
                                    });
                                    var lastRow = -1;
                                    if (summaryData.length < params.endRow) {
                                        lastRow = summaryData.length;
                                    }
                                    self.rowCount = summaryData.length;
                                    params.successCallback(slicedData, lastRow);
                                }
                                else {
                                    self.rowCount = 0;
                                    params.successCallback([], 0);
                                }
                            }, function (error) {
                                _this.agGrid.api.hideOverlay();
                            });
                        }
                    });
                }
                else {
                    _this.initialLoad = false;
                    self.fetchNextChunk(params.startRow, params.endRow).then(function (chunk) {
                        var slicedData = chunk.slice(params.startRow, params.endRow);
                        slicedData.forEach(function (data) {
                            data.id = data['#RowNumber'];
                        });
                        var lastRow = -1;
                        if (chunk.length < params.endRow) {
                            lastRow = chunk.length;
                        }
                        self.rowCount = chunk.length;
                        params.successCallback(slicedData, lastRow);
                    });
                }
            }
        };
        event.api.setDatasource(datasource);
        setTimeout(function () {
        });
    };
    AdvancedTableComponent.prototype.firstDataRendered = function (event) {
    };
    AdvancedTableComponent.prototype.sortChanged = function (event) {
        // console.log(event);
    };
    AdvancedTableComponent.prototype.filterChanged = function (event) {
        // console.log(event);
    };
    AdvancedTableComponent.prototype.dragStopped = function (event) {
    };
    AdvancedTableComponent.prototype.onChange = function (selectedColumn, event) {
        var column;
        column = this.columns.find(function (x) { return x.field == selectedColumn.field; });
        this.agGrid.columnApi.setColumnVisible(column.field, event.checked);
    };
    AdvancedTableComponent.prototype.fetchNextChunk = function (startRow, endRow) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.summaryService.nextPage(_this.componentId).subscribe(function (result) {
                if (result == "1") {
                    _this.summaryService.getSummary(_this.componentId).subscribe(function (result) {
                        var summary = JSON.parse(result);
                        _this.totalRowsCount = summary.TotalRows;
                        var summaryData = _this.sortSummaryData(summary.Data);
                        resolve(summaryData);
                    });
                }
            });
        });
    };
    AdvancedTableComponent.prototype.refreshSummary = function ($event) {
        var _this = this;
        var self = this;
        var datasource = {
            rowCount: null,
            getRows: function (params) {
                _this.agGrid.gridOptions.api.hideOverlay();
                if (params.startRow == 0) {
                    _this.summaryService.getSummary(_this.componentId).subscribe(function (result) {
                        var summary = JSON.parse(result);
                        var summaryData = _this.sortSummaryData(summary.Data);
                        _this.totalRowsCount = summary.TotalRows;
                        if (summaryData.length > 0) {
                            var slicedData = summaryData.slice(params.startRow, params.endRow);
                            slicedData.forEach(function (data) {
                                data.id = data['#RowNumber'];
                            });
                            var lastRow = -1;
                            if (summaryData.length < params.endRow) {
                                lastRow = summaryData.length;
                            }
                            self.rowCount = summaryData.length;
                            params.successCallback(slicedData, lastRow);
                        }
                        else {
                            self.rowCount = 0;
                            _this.agGrid.gridOptions.api.showNoRowsOverlay();
                            params.successCallback([], 0);
                        }
                    });
                }
                else {
                    _this.fetchNextChunk(params.startRow, params.endRow).then(function (chunk) {
                        var slicedData = chunk.slice(params.startRow, params.endRow);
                        slicedData.forEach(function (data) {
                            data.id = data['#RowNumber'];
                        });
                        var lastRow = -1;
                        if (chunk.length < params.endRow) {
                            lastRow = chunk.length;
                        }
                        self.rowCount = chunk.length;
                        params.successCallback(slicedData, lastRow);
                    });
                }
            }
        };
        this.agGrid.api.setDatasource(datasource);
    };
    AdvancedTableComponent.prototype.sortSummaryData = function (summaryData) {
        return summaryData.sort(function (a, b) {
            if (parseInt(a["#RowNumber"]) > parseInt(b["#RowNumber"])) {
                return 1;
            }
            else if (parseInt(a["#RowNumber"]) < parseInt(b["#RowNumber"])) {
                return -1;
            }
            else {
                return 0;
            }
        });
    };
    AdvancedTableComponent.prototype.sortByColumn = function (name) {
        if (this.cleanedColState.length > 0) {
            this.agGrid.columnApi.setColumnState(this.cleanedColState);
        }
        var self = this;
        var dataSource = {
            getRows: function (params) {
                var _this = this;
                if (params.startRow == 0 && !this.isFetching) {
                    this.isFetching = true;
                    self.agGrid.api.showLoadingOverlay();
                    self.summaryService.ChangeSummaryTableSorting(self.componentId, name).subscribe(function (result) {
                        if (result == "1") {
                            self.summaryService.getSummary(self.componentId).subscribe(function (result) {
                                var summary = JSON.parse(result);
                                _this.totalRowsCount = summary.TotalRows;
                                var summaryData = self.sortSummaryData(summary.Data);
                                summaryData.forEach(function (data, index) {
                                    data.id = data['#RowNumber'];
                                });
                                var lastRow = -1;
                                if (summaryData.length < params.endRow) {
                                    lastRow = summaryData.length;
                                }
                                _this.isFetching = false;
                                self.agGrid.api.hideOverlay();
                                self.rowCount = summaryData.length;
                                params.successCallback(summaryData, lastRow);
                            });
                        }
                    }, function (error) {
                        // self.agGrid.api.hideOverlay();
                    });
                }
                else {
                    self.fetchNextChunk(params.startRow, params.endRow).then(function (chunk) {
                        var slicedData = chunk.slice(params.startRow, params.endRow);
                        slicedData.forEach(function (data, index) {
                            data.id = data['#RowNumber'];
                        });
                        var lastRow = -1;
                        if (chunk.length < params.endRow) {
                            lastRow = chunk.length;
                        }
                        self.rowCount = chunk.length;
                        params.successCallback(slicedData, lastRow);
                    });
                }
            }
        };
        this.gridOptions.api.setDatasource(dataSource);
    };
    AdvancedTableComponent.prototype.onSave = function () {
        var _this = this;
        var columnsState = [];
        var sortModel = this.agGrid.gridOptions.api.getSortModel();
        this.agGrid.columnApi.getColumnState().forEach(function (element, index) {
            var sortCol = sortModel.find(function (x) { return x.colId == element.colId; });
            var colState = {
                field: element.colId,
                hide: element.hide,
                order: index,
                sort: sortCol ? sortCol.sort : null,
                width: element.width
            };
            columnsState.push(colState);
        });
        // this.isSaving = true;
        this.summaryService.updateSummaryColumnState(this.componentId, columnsState).subscribe(function (result) {
            if (result == "1") {
            }
            _this.isSaving = false;
        }, function (error) {
            _this.isSaving = false;
        });
    };
    AdvancedTableComponent.prototype.getState = function () {
        var _this = this;
        this.summaryService.getSummaryColumnState(this.componentId).subscribe(function (result) {
            if (result) {
                var colState = JSON.parse(result);
                _this.cleanedColState = [];
                if (colState) {
                    colState.forEach(function (element) {
                        var a = {
                            colId: element.field,
                            width: element.width,
                            hide: element.hide
                        };
                        if (element.hide) {
                            _this.columns.find(function (x) { return x.field == element.field; }).isChecked = false;
                        }
                        if (element.sort) {
                            _this.agGrid.columnApi.getColumn(element.field).setSort(element.sort);
                        }
                        _this.cleanedColState.push(a);
                    });
                }
                if (_this.cleanedColState.length > 0) {
                    _this.initialLoad = false;
                    _this.agGrid.columnApi.setColumnState(_this.cleanedColState);
                }
            }
        });
    };
    AdvancedTableComponent.prototype.export = function () {
        this.exportSummary.emit(!this.toggleClickExport);
    };
    AdvancedTableComponent.prototype.exportCurrent = function () {
        var columnsState = [];
        var sortModel = this.agGrid.gridOptions.api.getSortModel();
        this.agGrid.columnApi.getColumnState().forEach(function (element, index) {
            var sortCol = sortModel.find(function (x) { return x.colId == element.colId; });
            var colState = {
                field: element.colId,
                hide: element.hide,
                order: index,
                sort: sortCol ? sortCol.sort : null,
                width: element.width
            };
            columnsState.push(colState);
        });
        this.exportCurrentView.emit(columnsState);
    };
    return AdvancedTableComponent;
}());
export { AdvancedTableComponent };
